import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '../api';

/**
 * Shared QueryClient for the whole app.
 *
 * Defaults chosen for a parenting tool, not a stock ticker:
 *   - 5-minute stale time: per-baby data doesn't change minute-to-minute
 *   - No refetch on window focus: avoids surprise loading flickers
 *   - Single retry, only for transient network errors (skip 4xx)
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60_000,
      gcTime: 30 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
          return false;
        }
        return failureCount < 1;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
